import TargetObj from '@/assets/img/nodiscrimination/nodiscrimination_sec2_obj1@2x.png';
import StoryObj1 from '@/assets/img/nodiscrimination/nodiscrimination_story_obj1@2x.png';
import StoryObj2 from '@/assets/img/nodiscrimination/nodiscrimination_story_obj2@2x.png';
import StoryObj3 from '@/assets/img/nodiscrimination/nodiscrimination_story_obj3@2x.png';
import Section from '@/components/Section';
import SwiperBasic from '@/components/Swiper/SwiperBasic';
import { breakpoint } from '@/helpers/BreakpointHelper';
import styled from 'styled-components';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';

export const SectionTop = styled(Section)`
  .head-dec {
    margin-top: 24px;
  }
`;

export const SectionCard = styled(Section)`
  padding-bottom: 0 !important;

  ${breakpoint(`tablet`)} {
    padding-top: 0 !important;
  }
`;

export const SectionTarget = styled(Section)`
  overflow: inherit;

  .sec-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 0;

    .col-header {
      position: relative;
      width: 440px;

      &::before {
        content: '';
        display: block;
        width: 581px;
        height: 544px;
        background: url(${TargetObj}) center no-repeat;
        background-size: cover;
        position: absolute;
        left: -230px;
        top: -116px;
        z-index: 1;

        ${breakpoint(1160)} {
          width: 50.08vw;
          height: 46.9vw;
          left: -19.83vw;
          top: -10vw;
        }
        ${breakpoint(`mobile`)} {
          width: 277px;
          height: 260px;
          left: -110px;
          top: -55px;
        }
      }

      h2 {
        position: relative;
        z-index: 2;
        letter-spacing: -2.4px;
        white-space: nowrap;

        ${breakpoint(`mobile`)} {
          white-space: normal;
        }
      }
      .blit,
      .header-dec {
        position: relative;
        z-index: 2;
        margin-top: 96px;
        line-height: 2;

        ${breakpoint(`tablet`)} {
          margin-top: 72px;
        }
        strong {
          color: #1cabe2;
          font-weight: 400;
        }

        & > li {
          position: relative;
          padding-left: 15px;
          margin-bottom: 6px;

          &::before {
            content: '';
            display: block;
            width: 6px;
            height: 6px;
            border-radius: 100%;
            position: absolute;
            left: 0;
            top: 14px;
            background: #1cabe2;
          }
        }
      }
    }
  }

  ${breakpoint(`tablet`)} {
    padding-top: 120px !important;
    .col-header {
      .blit {
        & > li {
          &::before {
            top: 14px;
          }
        }
      }
    }
  }

  ${breakpoint(`mobile`)} {
    .sec-header {
      flex-wrap: wrap;

      .col-header {
        width: 100%;

        .blit {
          & > li {
            &::before {
              top: 10px;
            }
          }
        }
      }

      picture,
      img {
        width: 100%;
      }
    }
  }
`;

export const SectionWedo = styled(Section)`
  .accordion-opener {
    padding: 24px;
    cursor: pointer;
    font-weight: bold;
    font-size: 20px;
    position: relative;

    ${breakpoint(`tablet`)} {
      font-size: 16px;
      padding: 20px 0;
    }
  }

  .accordion-body {
    padding: 24px;
    padding-bottom: 32px;
    ${breakpoint(640)} {
      padding: 16px 0;
    }
  }
  .process-ol {
    justify-content: space-around;

    & > li {
      width: 33.33%;
      padding: 0 10px;
      margin-bottom: 32px;

      dt {
        padding: 0 !important;
      }
      dd {
        max-width: 210px;
        letter-spacing: -1px;
        line-height: 2;
        margin: 0 auto;
        color: #2d2926;

        .dec-ul {
          margin-top: 24px;
          strong {
            color: #1cabe2;
            font-weight: 400;
          }
        }
      }

      ${breakpoint(`mobile`)} {
        width: 50%;
      }
    }

    &.col4 > li {
      width: 25%;

      ${breakpoint(`mobile`)} {
        width: 50%;
      }
    }
  }

  .col_4 {
    .process-ol {
      & > li {
        width: 25%;

        ${breakpoint(`mobile`)} {
          width: 50%;
        }
      }
    }
  }
`;
export const SectionStroy = styled(Section)`
  .section-content {
    position: relative;
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;

    &::before,
    &::after {
      content: '';
      display: block;
      width: 1920px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }

    &::before {
      height: 637px;
      background: url(${StoryObj3}) left center no-repeat;
      background-size: auto 100%;
      top: 132px;
    }
    &::after {
      height: 288px;
      background: url(${StoryObj1}) right center no-repeat;
      background-size: auto 100%;
      top: -120px;
    }

    ${breakpoint(1160)} {
      &::before {
        width: 165.52vw;
        height: 54.91vw;
        top: 11.38vw;
      }
    }

    ${breakpoint(`tablet`)} {
      &::before {
        display: none;
      }
    }

    .content-container {
      position: relative;
      background: #1cabe2;
      padding-left: 60px;

      &::before,
      &::after {
        content: '';
        display: block;
        width: 1920px;
        position: absolute;
      }
      &::before {
        width: 288px;
        height: 288px;
        background: url(${StoryObj2}) center no-repeat;
        background-size: cover;
        bottom: 0;
        left: 0;
      }

      &::after {
        width: 960px;
        height: 100%;
        background: #1cabe2;
        top: 0;
        left: 50%;
      }

      .swiper-container {
        padding-bottom: 94px;
        overflow: hidden;

        .swiper-button-prev,
        .swiper-button-next {
          margin: 0;
          right: auto;
          bottom: 56px;
          display: block !important;
        }
        .swiper-button-prev {
          left: 348px;
        }
        .swiper-button-next {
          left: 428px;
        }

        .story-flex {
          display: flex;

          .col-img {
            width: 42.5%;
          }
          .col-dec {
            padding: 80px;
            padding-right: 30px;
            padding-bottom: 30px !important;
            width: 57.5%;

            header {
              p {
                color: #ffdc0e;
                margin-top: 6px;
              }
            }
            .dec {
              color: #fff;
              margin-top: 46px;
              line-height: 2;
            }
          }
        }
      }

      ${breakpoint(1160)} {
        padding-left: 5.17vw;

        .swiper-container {
          .story-flex {
            .col-dec {
              padding: 6.9vw;
              padding-right: 2.59vw;
            }
          }

          .swiper-button-prev {
            left: 30vw;
          }
          .swiper-button-next {
            left: calc(30vw + 80px);
          }
        }
      }

      ${breakpoint(`tablet`)} {
        &::before {
          width: 194px;
          height: 194px;
        }
      }

      ${breakpoint(`mobile`)} {
        padding: 0;
        margin: 0 -20px;

        .swiper-container {
          padding-bottom: 0;

          .swiper-button-prev,
          .swiper-button-next {
            bottom: auto;
            margin-left: 0;
            top: calc(114.06vw - 56px);
            z-index: 2;
            left: auto;
            right: 100px;
          }
          .swiper-button-next {
            right: 20px;
          }

          .story-flex {
            flex-wrap: wrap;
            padding: 0 20px;
            padding-bottom: 0;

            .col-img,
            .col-dec {
              width: 100%;
              padding: 0;
            }

            .col-img {
              margin-bottom: 40px;
              picture,
              img {
                width: 100%;
              }
            }
            .col-dec {
              padding-bottom: 0 !important;
            }
          }
        }
      }

      ${breakpoint(320)} {
        .swiper-container {
          .swiper-button-prev,
          .swiper-button-next {
            top: 309px;
          }
        }
      }
    }
  }
`;
export const StoryFlex = styled.div`
  display: flex;
`;
export const SwiperCustom = styled(SwiperBasic)`
  .swiper-slide {
    width: 200px;
    margin-right: 32px;
  }
`;

export const SectionNews = styled(Section)`
  .swiper-slide {
    width: 256px;

    .img-box {
      padding-top: 100%;
    }

    p {
      padding: 0;
      margin-top: 24px;
      display: -webkit-box;
      word-wrap: break-word;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      font-size: 20px;
      line-height: 1.6;
      min-height: 64px;
      border-radius: 0;
    }

    ${breakpoint(`mobile`)} {
      width: 150px;

      p {
        font-size: 14px;
        min-height: 44px;
      }
    }
  }
`;
